

document.querySelector('.buybutton-template--25700586684714__extra_button_wdChBq').onclick = clickBuyButton;

function clickBuyButton(e) {
    // Get the current quantity from the input field
    const quantityInput = document.querySelector('.product-form__quantity');
    let quantity = 1; // Default quantity value
    if (quantityInput) {
        quantity = quantityInput.value;
    } else {
        // If the quantity input doesn't exist, create a hidden input with a default quantity value
        document.querySelector('.product-form__buttons').insertAdjacentHTML('beforebegin', `
            <input class="product-form__quantity" type="hidden" name="quantity" value="${quantity}">
        `);
    }

    // Click the submit button
    document.querySelector('.product-form__submit').click();
}

